import stepTypes from 'components/Booking-new/modules/Steps/types';

import { updateURL } from 'components/Booking-new/utils/helpers';

const NO_SELECTED_LOCATION = {
  [stepTypes.location]: {
    selectedLocation: {},
    isSelected: false,
  },
};

const filterLocationsByState = (paramValue, state = null, key = 'state') => {
  if (paramValue === null || state === null) {
    updateURL(key);
    return state || {};
  }

  const locationSteps = state?.allSteps?.find(({ type }) => type === stepTypes.location);
  const indexOfLocationStep = state?.allSteps?.findIndex(({ type }) => type === stepTypes.location);

  if (typeof locationSteps === 'undefined') {
    updateURL(key);
    return state;
  }

  const locationsBasedOnState = [];

  locationSteps?.data?.locations?.map(location => {
    if (location.state === paramValue) locationsBasedOnState.push(location);
  });

  state.allSteps[indexOfLocationStep].data.locations = locationsBasedOnState;

  if (typeof locationsBasedOnState === 'undefined') {
    updateURL(key);
    return state;
  }

  return {
    ...state,
    userData: {
      ...(state.userData || {}),
      ...NO_SELECTED_LOCATION,
    },
  };
};

export default filterLocationsByState;
